import styled, { css } from 'styled-components';

import { minWidth } from '@calm-web/design-system';

const tabletStyles = css`
	flex: 0 0 80px;
	width: 80px;
	height: 80px;
`;

export const Wrapper = styled.div<{ $theme: string; $alignment: string }>`
	border-radius: 50%;
	flex: 0 0 48px;
	margin: ${p => (p.$alignment === 'center' ? '0 auto' : '0')};
	overflow: hidden;
	height: 48px;
	transform: translateZ(0);
	width: 48px;

	${minWidth('tablet')} {
		${p => p.$theme !== 'small' && tabletStyles}
	}
`;
